// The chats the Reviews lens opened with a kit of their own (Investigate's
// cases and scope coordination, and suggesting standards), kept in this
// browser by each chat's server id with what it was opened on, so a chat
// reloaded from storage is rebuilt with its kit rather than as a plain chat
// that has lost its tools. Per reader, the most recent few.
import { browserStorageKey } from "./browserStorageScope.js";

const PREFIX = "origin-investigate-chats-v1";
const KEPT = 60;

function readKept() {
    const key = browserStorageKey(PREFIX);
    if (!key) return {};
    try {
        const raw = JSON.parse(globalThis.localStorage?.getItem(key) || "null");
        return raw && typeof raw === "object" ? raw : {};
    } catch {
        return {};
    }
}

function writeKept(kept) {
    const key = browserStorageKey(PREFIX);
    if (!key) return;
    const entries = Object.entries(kept).sort((a, b) => (b[1]?.at || 0) - (a[1]?.at || 0)).slice(0, KEPT);
    try { globalThis.localStorage?.setItem(key, JSON.stringify(Object.fromEntries(entries))); } catch { /* a full store forgets the kit, not the chat */ }
}

// `ref` is the chat ({ serverChatId, chatId }); `spec` what it was opened on.
export function rememberChat(ref, spec) {
    const id = ref?.serverChatId;
    if (!id) return;
    writeKept({ ...readKept(), [id]: { spec, chatId: ref.chatId ?? null, at: Date.now() } });
}

// What a chat was opened on, by its server id, or null.
export function keptSpecOf(serverChatId) {
    return serverChatId ? readKept()[serverChatId]?.spec || null : null;
}

// The newest chat kept whose spec passes `test`, as a ref.
export function keptChatWhere(test) {
    const hit = Object.entries(readKept()).sort((a, b) => (b[1]?.at || 0) - (a[1]?.at || 0)).find(([, v]) => v?.spec && test(v.spec));
    return hit ? { serverChatId: hit[0], chatId: hit[1].chatId ?? null } : null;
}

// Lets go of the chats whose spec passes `test`: they stay in the console as
// chats, but Investigate no longer goes back to them or rebuilds their kit.
export function forgetChats(test) {
    const kept = readKept();
    const left = Object.fromEntries(Object.entries(kept).filter(([, v]) => !(v?.spec && test(v.spec))));
    if (Object.keys(left).length !== Object.keys(kept).length) writeKept(left);
}
